import { FunctionalComponent, h } from 'vue'
import { useRoute } from 'vue-router'

import { LayoutName } from './layouts'
import * as layouts from './layouts/layouts'

const Layout: FunctionalComponent = () => {
  const route = useRoute()

  const name: LayoutName = route.meta?.layout ?? 'blank'

  const Component = layouts[name]

  return h(Component)
}

export default Layout
